export enum OrderingDirection {
    Asc,
    Desc
}
